<template>
  <div>
    <ejs-grid ref="grid" :dataSource="data" :columns="tableColumns" :allowResizing="true"></ejs-grid>
  </div>
</template>
<script>
import Vue from 'vue';
import { GridPlugin, Resize } from '@syncfusion/ej2-vue-grids';

Vue.use(GridPlugin);
export default {
  data() {
    return {
      data: [{}],
      tableColumns: []
    };
  },

  provide: {
    grid: [Resize]
  },
  methods: {
    // 格式化数据，但是目前官方网站实例有问题。调用频频繁导致页面无法正常使用所以先预留方法
    dataBound: function () {},
    // 实时推送数据
    addAction: function (customData) {
      // 如果参数传过来的是数组（历史推送数据）直接附值
      if (Object.prototype.toString.call(customData) === '[object Array]') {
        this.buildTableColumns(customData[0]);
        this.data = [...customData];
      }
      // 如果推送过来的是对象则动态加入到当前的数据之中
      if (Object.prototype.toString.call(customData) === '[object Object]') {
        this.buildTableColumns(customData);
        if (JSON.stringify(this.data).toString() == '[{}]') {
          let temp = [];
          temp.unshift(customData);
          this.data = [...temp];
        } else {
          this.data.unshift(customData);
          this.data = [...this.data];
        }
      }

      if (this.data.length > 100) {
        this.data.pop();
      }
    },
    buildTableColumns(customData) {
      if (this.tableColumns.length === 0) {
        for (let item in customData) {
          switch (item) {
            case 'sys_meter_timely_task_id':
              this.tableColumns.push({
                field: 'sys_meter_timely_task_id',
                headerText: this.$t('Pm.taskID'),
                textAlign: 'center',
                clipMode: 'EllipsisWithTooltip'
              });
              break;

            case 'ne_id':
              this.tableColumns.push({
                field: 'ne_id',
                headerText: this.$t('Pm.ne_id'),
                textAlign: 'center',
                clipMode: 'EllipsisWithTooltip'
              });
              break;

            case 'ne_name':
              this.tableColumns.push({
                field: 'ne_name',
                headerText: this.$t('Pm.resource_name'),
                textAlign: 'center',
                clipMode: 'EllipsisWithTooltip'
              });
              break;

            case 'statistic_cycle':
              this.tableColumns.push({
                field: 'statistic_cycle',
                headerText: this.$t('Pm.samplingPeriod_unit'),
                textAlign: 'center',
                clipMode: 'EllipsisWithTooltip'
              });
              break;

            case 'Intodb_time':
              this.tableColumns.push({
                field: 'Intodb_time',
                headerText: this.$t('Pm.reportTime'),
                textAlign: 'center',
                clipMode: 'EllipsisWithTooltip'
              });
              break;

            case 'assoc_id':
              this.tableColumns.push({
                field: 'assoc_id',
                headerText: this.$t('Pm.assocId'),
                textAlign: 'center',
                clipMode: 'EllipsisWithTooltip'
              });
              break;

            case 'proId':
              this.tableColumns.push({
                field: 'proId',
                headerText: this.$t('Pm.processCode'),
                textAlign: 'center',
                clipMode: 'EllipsisWithTooltip'
              });
              break;

            default:
              this.tableColumns.push({
                field: item,
                headerText: item,
                textAlign: 'center',
                clipMode: 'EllipsisWithTooltip'
              });
              break;
          }
        }
      }
    }
  }
};
</script>
